export const calculateDownpayment = (value, percentage = 0.2) => {
  if (!value) return 0;
  const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.]/g, '')) : value;
  return numericValue * percentage;
};

export const calculateProfit = (marketValue, upsetValue) => {
  if (!marketValue || !upsetValue) return 0;
  return marketValue - upsetValue;
};

export const calculateProfitPercentage = (marketValue, upsetValue) => {
  if (!marketValue || !upsetValue) return 0;
  return ((marketValue - upsetValue) / upsetValue) * 100;
};

export const calculatePriceDifference = (upsetValue, zillowValue) => {
  if (!upsetValue || !zillowValue) return 'N/A';
  
  const upsetNumeric = typeof upsetValue === 'string' ? 
    parseFloat(upsetValue.replace(/[^0-9.]/g, '')) : upsetValue;
    
  const percentDiff = ((zillowValue - upsetNumeric) / upsetNumeric * 100).toFixed(1);
  return `${percentDiff > 0 ? '+' : ''}${percentDiff}%`;
};

export const calculateInvestmentPotential = (profit) => {
  if (profit > 50000) return { level: 'Excellent', color: 'bg-green-100 text-green-800' };
  if (profit > 25000) return { level: 'Good', color: 'bg-yellow-100 text-yellow-800' };
  if (profit > 0) return { level: 'Fair', color: 'bg-blue-100 text-blue-800' };
  return { level: 'Poor', color: 'bg-red-100 text-red-800' };
};

export const getProfitColor = (profit) => {
  if (profit > 50000) return 'bg-green-100 text-black';
  if (profit > 25000) return 'bg-blue-100 text-black';
  if (profit > 0) return 'bg-yellow-100 text-black';
  return 'bg-red-100 text-black';
};